import { Box, Button, Typography } from '@mui/material'
import CustomGrid from 'common/components/CustomGrid'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from 'features/users/stores/userSlice'
import useFetchMisEvaluaciones from '../hooks/useFetchMisEvaluaciones'
import EvaluacionCard from './EvaluacionCard'
import EvaluacionesTable from './EvaluacionesTable'

/**
 * @component
 * @param {Object} props
 * @param {Array} props.evaluaciones
 * @param {Function} props.setCurrentLevel
 * @param {boolean} [props.hideNav=false]
 * @param {Function} props.onCardClick
 * @param {boolean} props.viewAsAdmin
 * @param {Function} props.onToggleAdmin
 * @returns {JSX.Element}
 */
const MisEvaluaciones = ({
  evaluaciones: _propEvaluaciones,
  setCurrentLevel: _setCurrentLevel,
  hideNav: _hideNav = false,
  onCardClick,
  viewAsAdmin,
  onToggleAdmin,
}) => {
  const usuario = useSelector(selectCurrentUser)
  const { response, loading } = useFetchMisEvaluaciones(viewAsAdmin)

  const [datos, setDatos] = useState(response)

  useEffect(() => {
    setDatos(response)
  }, [response])

  const is_admin = usuario?.admin_evaluaciones === 'S'
  const skeletons = Array.from({ length: 6 }, (_, i) => ({ id: `skeleton-${i}` }))

  return (
    <Box sx={{ p: 2 }}>
      {is_admin && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <Button variant="outlined" onClick={() => onToggleAdmin(!viewAsAdmin)}>
            {viewAsAdmin ? 'Vista normal' : 'Vista administrador'}
          </Button>
        </Box>
      )}
      <Box>
        {/* Vista de cards — móvil y tablet portrait */}
        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
          {!loading && datos?.length === 0 && (
            <Box sx={{ textAlign: 'center', py: 6 }}>
              <Typography variant="body1" color="text.secondary">
                No hay evaluaciones disponibles.
              </Typography>
            </Box>
          )}
          <CustomGrid
            dataSource={loading ? skeletons : datos || []}
            CardLayout={({ data }) => (
              <EvaluacionCard loading={loading} evaluacion={data} onClick={onCardClick} />
            )}
            loading={false}
            gridProps={{ spacing: 2, container: true }}
            gridItemsProps={{ md: 4, sm: 6, xs: 12 }}
          />
        </Box>

        {/* Vista de tabla — tablet landscape y superior */}
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <EvaluacionesTable
            evaluaciones={loading ? [] : datos}
            loading={loading}
            onClickEvent={onCardClick}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default MisEvaluaciones
